// @ts-nocheck

import { GridsActionTypes } from '../types/actions';

export const askInitialState = () => ({
  type: GridsActionTypes.INIT,
});
